@let ctx =
  {
    setupPhase: (setupPhase$ | async),
    loadingDialog: (loadingDialog$ | async),
    coupledConnector: (coupledConnector$ | async),
  };

<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Typeform</div>
  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    @if (isCopyConfigurationButtonVisible) {
      <blaze-copy-connector-config-env-button
        [coupledConnector]="ctx.coupledConnector"
        (copyConfiguration)="copyConfiguration($event)"
      />
    }
    @if (isAuthorizeButtonVisible) {
      <button [disabled]="ctx.loadingDialog" (click)="goToAuth()" blazeBarButton="secondary">
        authorize
      </button>
    }
    @if (isFormButtonVisible) {
      <button [disabled]="ctx.loadingDialog" (click)="goToForm()" blazeBarButton="secondary">
        show form
      </button>
    }
    @if (isSaveButtonVisible) {
      <button
        [disabled]="connectorForm.invalid || !!(loading$ | async)?.connector || ctx.loadingDialog"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        {{ saveButtonLabel }}
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    @if (ctx.loadingDialog === false) {
      <div class="flex flex-col items-center">
        @switch (ctx.setupPhase) {
          @case (SetupPhase.Authorization) {
            <ng-template [ngTemplateOutlet]="authorizationTpl" />
          }
          @case (SetupPhase.PopupOpened) {
            <ng-template [ngTemplateOutlet]="popupOpenedTpl" />
          }
          @case (SetupPhase.ConnectorCreation) {
            <ng-template [ngTemplateOutlet]="connectorCreationTpl" />
          }
        }
      </div>
    }
    <blaze-element-loading-indicator [isVisible]="ctx.loadingDialog" />
  </div>
</blaze-panel>

<ng-template #authorizationTpl>
  <h3 class="mb-16">To create connector sign in to Typeform</h3>
  <button
    blazeButton
    blazeIconButtonSize="xl"
    class="bd"
    [disabled]="!authorizationUrl"
    (click)="connect()"
    >Sign in to Typeform</button
  >
</ng-template>

<ng-template #popupOpenedTpl>
  <h3 class="mb-16">Please follow instructions in opened window.</h3>
  <button blazeButton (click)="focusOpenedWindow()"> Focus window </button>
</ng-template>

<ng-template #connectorCreationTpl>
  @let ctx =
    {
      forms: (availableFormsOptions$ | async) ?? [],
      projects: (availableProjectOptions$ | async) ?? [],
      tables: (availableTablesOptions$ | async) ?? [],
      mappings: (availableMappings$ | async) ?? [],
      loading: (loading$ | async),
    };

  <form class="flex flex-col w-full" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
    <div class="form-control mb-22">
      <label class="field-label bd-field-label required">Name your connector</label>
      <input formControlName="connectorName" name="connectorName" class="bd-text-input tall" />
    </div>
    <div class="form-control">
      <blaze-webhook-id-input [baseUrl]="webhookBaseUrl" formControlName="webhookId" />
    </div>
    <div class="form-control">
      <blaze-secret-input formControlName="secret" />
    </div>
    <div class="form-control">
      <label class="field-label bd-field-label required">Form</label>
      <div class="relative">
        <blaze-select
          [showSelection]="true"
          [multiselect]="false"
          [filtered]="true"
          [allowNone]="false"
          [formControl]="connectorForm.controls.formId"
          [options]="ctx.forms"
        />
        <blaze-element-loading-indicator [isVisible]="ctx.loading?.forms" />
      </div>
    </div>

    <div class="form-control">
      <label class="field-label bd-field-label required">Project</label>
      <div class="relative">
        <blaze-select
          [showSelection]="true"
          [multiselect]="false"
          [filtered]="true"
          [allowNone]="false"
          [formControl]="connectorForm.controls.projectId"
          [options]="ctx.projects"
        />
        <blaze-element-loading-indicator [isVisible]="ctx.loading?.projects" />
      </div>
    </div>

    <div class="form-control">
      <label class="field-label bd-field-label required">Table</label>
      <div class="relative">
        <blaze-select
          [showSelection]="true"
          [multiselect]="false"
          [filtered]="true"
          [allowNone]="false"
          [formControl]="connectorForm.controls.tableId"
          [options]="ctx.tables"
          [disabled]="isTableSelectDisabled"
        />
        <blaze-element-loading-indicator [isVisible]="ctx.loading?.tables" />
      </div>
    </div>

    <div class="form-control" formArrayName="mappings">
      <div class="tables">
        <label class="table-name-label field-label bd-field-label required">Form field</label>
        <label class="table-field-label field-label bd-field-label">Table column</label>

        @for (
          mapping of connectorForm.controls.mappings.controls;
          track mapping;
          let index = $index
        ) {
          <blaze-mapping-row
            [form]="mapping"
            [availableMappings]="ctx.mappings"
            [canRemove]="canRemoveMapping"
            (remove)="removeMapping(index)"
          />
        }

        <div class="table-summary">
          <button
            blazeButton="secondary"
            class="add-table-btn"
            (click)="addMapping()"
            type="button"
            blazeTooltip="Add mapping"
          >
            <mat-icon svgIcon="icon_add_32" />
            Mapping
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
